/**
 * Renders the startup preloader during GET /auth/me. Must live under BrowserRouter for path-aware placement.
 */

import { useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { GlobalPreloader } from '@components/GlobalPreloader';
import { BACKOFFICE_BASE, BACKOFFICE_LOGIN_PATH } from '@lib/backofficeRoutes';

export function AuthLoadingOverlay() {
  const { authLoading } = useAuth();
  const location = useLocation();

  if (!authLoading) return null;

  const path = location.pathname;
  const useBackofficeMainColumn =
    path.startsWith(BACKOFFICE_BASE) && path !== BACKOFFICE_LOGIN_PATH;

  return (
    <GlobalPreloader placement={useBackofficeMainColumn ? 'backofficeMainColumn' : 'viewport'} />
  );
}
